module.exports = __webpack_public_path__ + "static/media/gatehouse.9668e96d.png";